/**
 * Created by JIocb on 19.06.2017.
 */
namespace Factive.Game {
    import Signal = Factive.Core.Signal.Signal;
    export class GameRoomModel
    {
        private NUM_ROLLS_FOR_ROUND:number = 3;
        private _currentRoundNumRolls:number = 0;

        private _userScore:UserScoreModel;
        private _userBag:UserBagModel;
        private _scoreTable:ScoreTableModel;
        private _history:Array<any> = [];
        public signal:Signal = new Signal();
        private _roundNumber:number = 0;
        private _numberOfTotalRolls: number = 0;
        private _isBonusMode:boolean = false;
        private _lastDiceRollResult:Array<DiceData>;
        private _achievementHictory:any = {};
        private ACHIEVEMENT_SCORE_STEP:number = 500;

        public constructor()
        {
            this.create()
        }

        public create():void
        {
            this._userScore = new UserScoreModel();
            this._userBag = new UserBagModel();
            this._scoreTable = new ScoreTableModel();

            this._currentRoundNumRolls = this.NUM_ROLLS_FOR_ROUND;
        }

        public getScoreTableModel():ScoreTableModel
        {
            return this._scoreTable;
        }

        public getUserBagModel():UserBagModel
        {
            return this._userBag;
        }

        public finishRoll(result:Array<DiceData>):void
        {
            this._lastDiceRollResult = result.slice();
            var dices = result.concat([]);//this._userBag.getDices()
            this._scoreTable.predictScoresForDices(dices,1);

            this._userBag.lock(false);

            if(this.checkColors(dices))
            {
                this.signal.dispatch("color_bonus_available");
            }
        }

        public checkColors(dices: Array<DiceData>): boolean {

            if(!dices || dices.length == 0) return false;
            for (var i: number = 0; i < 5; i++) {
                if (dices[i].color != dices[0].color) {
                    return false;
                }
            }

            return true;
        }

        private checkForANewAchievement():any
        {
            var score:number = this.totalScore;
            if(score<this.ACHIEVEMENT_SCORE_STEP) return;

            var score:number = Math.floor(score/this.ACHIEVEMENT_SCORE_STEP)*this.ACHIEVEMENT_SCORE_STEP;

            if(this._achievementHictory[score]!=true)
            {
                this._achievementHictory[score] = true;

                return{score:score, stars:Math.floor((score/this.ACHIEVEMENT_SCORE_STEP)/2)}
            }

            return null;
        }


        public get isBonusMode():boolean
        {
            return this._isBonusMode;
        }

        public showAllDicesInBug():void {
            let l:number = this._lastDiceRollResult.length;
            this._bagDicesIds = this.getUserBagModel().getBagDicesIds();
            for(let i:number = 0; i<l; i++)
            {
                if(this._bagDicesIds.indexOf(this._lastDiceRollResult[i].id)!=-1){
                    continue;
                }
                this._userBag.addToBag(this._lastDiceRollResult[i]);
            }
            this._userBag.lock(true);
        }

        private _bagDicesIds:Array<number>;
        public unshowAllDicesInBug():void {
            let l:number = this._lastDiceRollResult.length;
            for(let i:number = 0; i<l; i++)
            {
                if(this._bagDicesIds.indexOf(this._lastDiceRollResult[i].id)!=-1){
                    continue;
                }
                this._userBag.removeFromBag(this._lastDiceRollResult[i]);
            }
            this._userBag.lock(false);
            this._bagDicesIds = null;
        }

        public activateBonusMode():void
        {
            this._isBonusMode= true;
            let l:number = this._lastDiceRollResult.length;

            for(let i:number = 0; i<l; i++)
            {
                this._userBag.addToBag(this._lastDiceRollResult[i]);
            }
            this._userBag.lock(true);
            //this._lastDiceRollResult = null;
            this._currentRoundNumRolls = 1;
        };

        public finishBonusMode(bonusMultiplier:number):void
        {
            let dices = this._lastDiceRollResult;//this._userBag.getDices()
            this._scoreTable.predictScoresForDices(dices,bonusMultiplier);
            this._lastDiceRollResult = null;
            this._isBonusMode = false;
        };


        public roll():void
        {
            this._userBag.lock(true);
            if(this.isBonusMode == false)
            {
                this.clearHistory();
            }

            if(this._currentRoundNumRolls == this.NUM_ROLLS_FOR_ROUND)
            {
                this._roundNumber++;
                this._userBag.clearTheBag();

                var result = this.checkForANewAchievement();
                {
                    if(result!=null)
                    {
                        this.signal.dispatch("new_achievement",result);
                    }
                }

                this.signal.dispatch("started_new_round");
            }

            this._scoreTable.clean();
            this._currentRoundNumRolls--;

            this._numberOfTotalRolls++;
            this.signal.dispatch("rolled");
        }

        public addDiceToBag(dice:DiceData):void
        {
            this._userBag.addToBag(dice);
        }


        private saveHistory(scoreCombination:number,multiplier:number):void
        {
            this._history[0] = this._history[0] || {};
            this._history[0].id = scoreCombination;
            this._history[0].multiplier = multiplier;

            if(this._history[0].roundNumber!=this._roundNumber)
            {

                this._history[0].numRollsLeft = this.numRollsLeft;
            }
            else
            {
                //console.log("SAVE HISTORY THE SAME ROUND")

            }
            this._history[0].roundNumber=this._roundNumber;
        }

        private getHistory():Object
        {
            var obj = this._history[0];
            if(obj) {
                var objCopy = {};
                var keys: Array<any> = Object.keys(obj);
                for (var i: number = 0; i < keys.length; i++) {
                    objCopy[keys[i]] = obj[keys[i]];
                }
                return objCopy;
            }
            return null;
        }

        private clearHistory():void
        {
            this._history.length = 0;
        }

        public saveScore(scoreCombination:number,multiplier:number):void
        {
            var obj:any = this.getHistory();
            this.saveHistory(scoreCombination,multiplier);

            if(obj != null && obj.id != undefined && obj.roundNumber == this._roundNumber)
            {
                this._scoreTable.unfreezeScore(obj.id,obj.multiplier);
            }

            this._scoreTable.freezeScore(scoreCombination,multiplier);

            if(this._scoreTable.numFrozenCombinations == (13*3))
            {
                this._userBag.lock(true);
                this.signal.dispatch("game_end",{score:this._scoreTable.totalScore});
            }
            else
            {
                this._userBag.clearTheBag();
                this._currentRoundNumRolls = this.NUM_ROLLS_FOR_ROUND;
                this.signal.dispatch("round_finished");
            }
        };


        public isUndoAvailable():boolean
        {
            return (this.getHistory()!=null)
        };

        public get totalScore():number
        {
            return this._scoreTable.totalScore;
        }

        public undo():void
        {
            var obj:any = this.getHistory();
            this.clearHistory();

            this._scoreTable.unfreezeScore(obj.id,obj.multiplier);
            this._currentRoundNumRolls = obj.numRollsLeft;

            this._userBag.undo();

            this.signal.dispatch("round_undoed");
        };

        public get numRollsLeft():number
        {
            return this._currentRoundNumRolls;
        };

        public getBagLength():number {
            return this._userBag.getDices().length;
        }

        public lockScoreTableInput(b: boolean) {
            this._scoreTable.lock = b;
        }

        public get numberOfTotalRolls():number
        {
            return this._numberOfTotalRolls;
        };

        public destroy() {
            this._numberOfTotalRolls = 0;
        }
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/Model/GameRoomModel.ts